import React from 'react';
import "../styles.scss";
import ExperienceCard from './ExperienceCard';
import { useLanguage } from '../context/LanguageContext';
import ceiiaIcon from '../assets/companies/ceiia.png';
import blipIcon from '../assets/companies/blip.png';
import communyIcon from '../assets/companies/communy.png';
import eldoradoIcon from '../assets/companies/eldorado.png';
import itsectorIcon from '../assets/companies/itSector.png';
import neemuIcon from '../assets/companies/neemu.png';
import redeIcon from '../assets/companies/redeAmazonica.png';
import sidiaIcon from '../assets/companies/sidia.png';

const Projects = () => {
    const { t } = useLanguage();
    const experiences = [
        { imgSrc: ceiiaIcon, ...t.experience.experiences[0] },
        { imgSrc: blipIcon, ...t.experience.experiences[1] },
        { imgSrc: itsectorIcon, ...t.experience.experiences[2] },
        { imgSrc: eldoradoIcon, ...t.experience.experiences[3] },
        { imgSrc: sidiaIcon, ...t.experience.experiences[4] },
        { imgSrc: neemuIcon, ...t.experience.experiences[5] },
        { imgSrc: communyIcon, ...t.experience.experiences[6] },
        { imgSrc: redeIcon, ...t.experience.experiences[7] }
    ];

    return (
        <div>
            <h1 className="text-wrap">{t.experience.title}</h1>
            <p className="text-white experience-intro">{t.experience.intro}</p>
            <div className="experience-overview row g-3">
                {t.experience.stats.map((item) => (
                    <div className="col-md-4" key={`${item.number}-${item.label}`}>
                        <div className="experience-stat">
                            <span className="experience-stat-number">{item.number}</span>
                            <span className="experience-stat-label">{item.label}</span>
                        </div>
                    </div>
                ))}
            </div>
            <div className="project-descrition">
                {experiences.map((exp) => (
                    <ExperienceCard
                        key={`${exp.company}-${exp.date}`}
                        imgSrc={exp.imgSrc}
                        company={exp.company}
                        location={exp.location}
                        role={exp.role}
                        date={exp.date}
                        description={exp.description}
                        highlights={exp.highlights}
                        stack={exp.stack}
                    />
                ))}
            </div>
        </div >
    );
};

export default Projects;
